import { memo } from 'react';
import { useIntl } from 'react-intl';
import { VStack } from '@cbhq/cds-web/layout';
import { TextHeadline } from '@cbhq/cds-web/typography';
import '../../../../../LanguageSelector/index.js';
import messages from '../../../../../LanguageSelector/messages.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import LanguageSelector from '../../../../../LanguageSelector/LanguageSelector.js';
function TrapdoorContentLanguageSelector({
  userLocaleInfo,
  localeInformation,
  onMouseLeave
}) {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/jsxs(VStack, {
    width: "100%",
    height: "100%",
    onMouseLeave: onMouseLeave,
    children: [/*#__PURE__*/jsx(TextHeadline, {
      as: "h2",
      color: "foregroundMuted",
      spacing: 2,
      children: formatMessage(messages.title)
    }), /*#__PURE__*/jsx(LanguageSelector, {
      userLocaleInfo: userLocaleInfo,
      localeInformation: localeInformation
    })]
  });
}
const LanguageSelectorContent = /*#__PURE__*/memo(TrapdoorContentLanguageSelector);
export { LanguageSelectorContent as default };
//# sourceMappingURL=LanguageSelector.js.map
